export const actionTypes = {
    getData: "[importLog] Get data",
};

export const mutationTypes = {
    importLogGetDataStart: "[importLog] Import log get data start",
    importLogGetDataSuccess: "[importLog] Import log get data success",
    importLogGetDataFailure: "[importLog] Import log get data failure",
};

export const getterTypes = {
    getImportLogs: "[importLog] Get import logs",
    isLoading: "[importLog] Is loading",
};
